import { useCallback, useEffect, useState } from 'react';

import { createTranslationFeedback, getTranslationFeedback } from '../data/api';

export const GRATITUDE_TEXT_TIMEOUT = 3000;

const useFeedbackWidget = ({
  courseId,
  courseLanguage,
  translationLanguage,
  unitId,
  userId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showFeedbackWidget, setShowFeedbackWidget] = useState(false);
  const [showGratitudeText, setShowGratitudeText] = useState(false);

  const closeFeedbackWidget = useCallback(() => {
    setShowFeedbackWidget(false);
  }, [setShowFeedbackWidget]);

  const openFeedbackWidget = useCallback(() => {
    setShowFeedbackWidget(true);
  }, [setShowFeedbackWidget]);

  useEffect(() => {
    const getShouldShowWidget = async () => {
      let showWidget = false;
      if (courseLanguage !== translationLanguage) {
        const translationFeedback = await getTranslationFeedback({
          courseId,
          translationLanguage,
          unitId,
          userId,
        });
        showWidget = !translationFeedback;
      }
      setShowFeedbackWidget(showWidget);
    };
    getShouldShowWidget();
  }, [
    courseId,
    courseLanguage,
    translationLanguage,
    unitId,
    userId,
  ]);

  const openGratitudeText = useCallback(() => {
    setShowGratitudeText(true);
    setTimeout(() => {
      setShowGratitudeText(false);
    }, GRATITUDE_TEXT_TIMEOUT);
  }, [setShowGratitudeText]);

  const sendFeedback = useCallback(async (feedbackValue, feedbackDetails = '', emailMe = true, reasonList = []) => {
    setIsLoading(true);
    await createTranslationFeedback({
      courseId,
      translationLanguage,
      unitId,
      userId,
      feedbackValue,
      feedbackDetails,
      emailMe,
      reasonList,
    });
    setIsLoading(false);
    closeFeedbackWidget();
    openGratitudeText();
  }, [
    courseId,
    translationLanguage,
    unitId,
    userId,
    closeFeedbackWidget,
    openGratitudeText,
  ]);

  const onSendPositiveFeedback = useCallback((feedbackDetails, emailMe) => {
    sendFeedback(true, feedbackDetails, emailMe);
  }, [sendFeedback]);

  const onSendNegativeFeedback = useCallback((reasonList, feedbackDetails, emailMe) => {
    sendFeedback(false, feedbackDetails, emailMe, reasonList);
  }, [sendFeedback]);

  return {
    closeFeedbackWidget,
    isLoading,
    openFeedbackWidget,
    openGratitudeText,
    sendFeedback,
    showFeedbackWidget,
    showGratitudeText,
    onSendPositiveFeedback,
    onSendNegativeFeedback,
  };
};

export default useFeedbackWidget;
